import React from "react";
import { UncontrolledTooltip } from "reactstrap";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import { Animated } from "react-animated-css";
import moment from "moment";

import api from "../../services/Api";
import Aux from "../hoc/Aux";

import AlertIcon from "../../assets/img/sireneEx.svg";
import WarningIcon from "../../assets/img/warning.svg";
import ClockIcon from "../../assets/img/hourglass.svg";
import Loading from "../Loading";

export default class DispositivosList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalMot: false,
      message: "",
      marcas: [],
      modalIndeferido: false,
      modalIndefText: "",
    };
  }
  //constructor

  componentWillMount() {
    api.loadAux().then((resp) => {
      this.setState({ marcas: resp.data[0].MARCAS });
    });
  }
  // carrega os dados de tabelas AUX

  tratarConfirmacao = (conf, value, index) => {
    switch (conf.confirmacao) {
      case "0":
        return <div style={{ textAlign: "center" }}>- -</div>;
      case "1":
        return (
          <div id={`pendente-${index}`}>
            <UncontrolledTooltip placement="bottom" target={`pendente-${index}`}>
              Aguardando validação da Secretaria de Segurança. Esta operação pode levar algumas
              horas!
            </UncontrolledTooltip>
            PENDENTE
            <img
              alt="pendente"
              style={{ height: "30px", weight: "20px", paddingBottom: "8px", paddingLeft: "5px" }}
              src={ClockIcon}
            />
          </div>
        );
      case "2":
        return (
          <div id={`confirmado-${index}`}>
            <UncontrolledTooltip placement="bottom" target={`confirmado-${index}`}>
              As informações foram confirmadas.
            </UncontrolledTooltip>
            CONFIRMADO
            <img
              alt="confirmado"
              style={{ height: "30px", weight: "20px", paddingBottom: "8px", paddingLeft: "5px" }}
              src={AlertIcon}
            />
          </div>
        );
      case "3":
        return (
          <div id={`indeferido-${index}`}>
            <a href className="text-link" onClick={() => this.modalIndef(value)}>
              INDEFERIDO
            </a>
            <img
              alt="indeferido"
              style={{ height: "30px", weight: "20px", paddingBottom: "8px", paddingLeft: "5px" }}
              src={WarningIcon}
            />
          </div>
        );
      default:
        return <div style={{ textAlign: "center" }}>- -</div>;
    }
  };
  //trata a confirmação

  buttonEdit = (value) => {
    if (value === "0") {
      return false;
    } else if (value === null) {
      return false;
    } else if (value === "3") {
      return false;
    } else if (value === "2") {
      return false;
    } else {
      return true;
    }
  };
  //habilita o botão de edição do dispositivo

  renderRows = () => {
    const list = this.props.list || [];
    return list.map((Dispositivos, index) => {
      const stripped = index % 2 === 0 ? "tr-stripped" : "tr-no-stripped";
      return (
        <Aux key={index}>
          <tr className={stripped + " tr-stripped-bt text-left"}>
            <td>{Dispositivos.imei}</td>
            <td>{Dispositivos.marca}</td>
            <td>{Dispositivos.modelo}</td>
            <td>{Dispositivos.serial}</td>
            <td>{Dispositivos.situacao}</td>
            <td>{this.tratarConfirmacao(Dispositivos, Dispositivos.obs_confirmacao, index)}</td>
            <td rowSpan="2">
              <div className="btn-actions">
                {this.buttonEdit(Dispositivos.confirmacao) ? null : (
                  <button
                    id={`btnEdit${index}`}
                    className="btn btn-info btn-action"
                    onClick={() => this.props.handleEdit(Dispositivos.id)}
                  >
                    <i className="mdi mdi-edit"></i>
                    <UncontrolledTooltip target={`btnEdit${index}`} delay={{ show: 0, hide: 0 }}>
                      Editar
                    </UncontrolledTooltip>
                  </button>
                )}
                <button
                  id={`btnRemove${index}`}
                  className="btn btn-danger btn-action"
                  onClick={() => this.props.handleDeleteId(Dispositivos.id)}
                >
                  <i className="mdi mdi-delete"></i>
                  <UncontrolledTooltip target={`btnRemove${index}`} delay={{ show: 0, hide: 0 }}>
                    Excluir
                  </UncontrolledTooltip>
                </button>
              </div>
            </td>
          </tr>
          <tr className={stripped}>
            <td className="td-second-line" colSpan="6">
              <span className="float-left">
                <strong>Telefone:</strong>&nbsp;
                {Dispositivos.telefone}
              </span>
              <span className="float-left text-left">
                <strong>Data de criação:</strong>&nbsp;
                {moment(Dispositivos.created_at).format("DD/MM/YYYY HH:mm")}
              </span>
            </td>
          </tr>
        </Aux>
      );
    });
  };
  //lista de dispositivos

  renderLog = () => {
    const list = this.props.loglist || [];
    return list.map((Dispositivos, index) => (
      <tr key={index} className="text-left">
        <td>{Dispositivos.imei}</td>
        <td>{Dispositivos.marca}</td>
        <td>{Dispositivos.modelo}</td>
        <td>{Dispositivos.serial}</td>
        <td>{Dispositivos.telefone}</td>
        <td>{Dispositivos.situacao}</td>
        <td>
          <button
            className="btn btn-secondary"
            onClick={(event) => this.tratarMotivo(Dispositivos.motivo)}
          >
            <i className="fa fa-book-open"></i>
          </button>
        </td>
      </tr>
    ));
  };
  // lista os dispositivos que foram deletados

  tratarMotivo = (motivo) => {
    switch (motivo) {
      case "1":
        this.setState({ message: "Negociei meu aparelho com outra pessoa" });
        break;
      case "2":
        this.setState({ message: "Aparelho com avaria / desuso" });
        break;
      case "3":
        this.setState({ message: "Outro motivo" });
        break;
      default:
        break;
    }
    this.modalMotivo();
  };
  // trata o motivo da exclusão de um dispositivo

  modalMotivo = () => {
    this.setState({ modalMot: !this.state.modalMot });
  };
  //modal do motivo

  modalIndef = (value) => {
    this.setState({
      modalIndeferido: !this.state.modalIndeferido,
      modalIndefText: value,
    });
  };
  // chama o modal do indeferido

  handleModalIndef = () => {
    return (
      <div>
        <Modal isOpen={this.state.modalIndeferido} style={{ color: "black" }}>
          <ModalBody>
            <h4>Indeferido por:</h4>
            <p>{this.state.modalIndefText}</p>
          </ModalBody>
          <ModalFooter>
            <button className="btn btn-primary" onClick={this.modalIndef}>
              Fechar
            </button>
          </ModalFooter>
        </Modal>
      </div>
    );
  };
  // modal indeferido

  render() {
    return (
      <div style={{ position: "relative" }}>
        <Modal isOpen={this.state.modalMot} style={{ color: "black" }}>
          <ModalBody>
            <h4>Motivo informado na exclusão:</h4>
            <p>{this.state.message}</p>
          </ModalBody>
          <ModalFooter>
            <button className="btn btn-primary" onClick={this.modalMotivo}>
              Fechar
            </button>
          </ModalFooter>
        </Modal>
        <div>
          {this.state.modalIndeferido ? this.handleModalIndef() : null}
          {!this.props.showDelete ? (
            <Animated
              animationIn="fadeIn"
              animationOut="fadeOut"
              isVisible={this.props.tablesTransiction}
            >
              <div>
                <table className="table table-responsive-sm table-responsive-md table-responsive-lg table-dispositivos">
                  <thead>
                    <tr className="text-left">
                      <th>IMEI Celular</th>
                      <th>Marca</th>
                      <th>Modelo</th>
                      <th>Serial</th>
                      <th>Situação</th>
                      <th>Análise B.O</th>
                      <th className="text-right">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={this.props.handlePush}
                        >
                          <i className="fa fa-sync-alt"></i>
                          &nbsp; Atualizar
                        </button>
                      </th>
                    </tr>
                  </thead>
                  <tbody>{this.props.loadList ? this.renderRows() : null}</tbody>
                </table>
                {!this.props.loadList ? (
                  <div style={{ paddingLeft: "40%" }}>
                    <Loading />
                  </div>
                ) : null}
              </div>
            </Animated>
          ) : (
            <div>
              <Animated
                animationIn="fadeIn"
                animationOut="fadeOut"
                isVisible={this.props.tablesTransiction}
              >
                <table className="table table-striped table-responsive-sm table-responsive-md table-responsive-lg">
                  <thead>
                    <tr>
                      <th className="text-left">IMEI Celular</th>
                      <th>Marca</th>
                      <th>Modelo</th>
                      <th>Serial</th>
                      <th>Telefone</th>
                      <th>Situação</th>
                      <th>Motivo</th>
                    </tr>
                  </thead>
                  <tbody>{this.renderLog() ? this.renderLog() : null}</tbody>
                </table>
              </Animated>
            </div>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Dispositivos/DispositivosList.js